import { render, staticRenderFns } from "./MauthTable.vue?vue&type=template&id=5c0c2840&scoped=true&"
import script from "./MauthTable.vue?vue&type=script&lang=js&"
export * from "./MauthTable.vue?vue&type=script&lang=js&"
import style0 from "./MauthTable.vue?vue&type=style&index=0&id=5c0c2840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0c2840",
  null
  
)

export default component.exports